import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import KarenCoin from "../../../../../../../../media/images/icons/karenCoin.svg";
import ClockOutline from "../../../../../../../../media/images/icons/clock";
import CustomButton from "../../../../../../../components/CustomButton";
import ArrowLeftCircle from "../../../../../../../../media/images/icons/arrow-left-circle";
import Check3d from "../../../../../../../../media/images/icons/check3d.png";
import { Link } from "react-router-dom";
import ArrowLeftSVG from "../../../../../../../../media/images/icons/arrow-left";

export default function RewardCard() {
  const theme = useTheme();
  return (
    <Grid
      container
      sx={{
        display: "flex",
        border: "1px solid gray",
        borderRadius: "16px",

        height: "100%",
      }}
    >
      <Grid item xs={3}>
        <Box
          sx={{
            height: "100%",
            backgroundColor: "info.light",
            display: "flex",
            borderRadius: "0 16px 16px 0",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            style={{
              width: "70px",
              // height: "100%",
            }}
            src={Check3d}
            alt=""
          />
        </Box>
      </Grid>
      <Grid item xs={9}>
        <Box
          sx={{
            backgroundColor: "background.default",
            borderRadius: "16px 0 0 16px",
            paddingY: "8px",
            paddingX: "8px",
            //   border: "1px solid gray",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            یک ماه{" "}
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "600",
              }}
              component="span"
              color={"secondary.main"}
            >
              اشتراک طلایی{" "}
            </Typography>
            بازارگاه + 10درصد تخفیف کارمزد{" "}
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography>امتیاز مورد نیاز:</Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  width: "fit-content",
                  // backgroundColor: "#424242",
                }}
              >
                <img width={18} src={KarenCoin} alt="" />
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                  color={"#424242"}
                >
                  47
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                  color={"#424242"}
                >
                  کارن پوینت
                </Typography>
              </Box>
            </Box>
            <Link
              to={"#"}
              style={{
                padding: "8px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                backgroundColor: theme.palette.secondary.main,
              }}
            >
              <Typography color="#fff" fontWeight={600}>
                مشاهده و دریافت
              </Typography>
              <ArrowLeftSVG color="#fff" />
            </Link>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
